import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { AuthProvider } from "./context/Auth/AuthContext";
import { ThemeModeProvider, useThemeMode } from "./context/ThemeMode/ThemeModeContext";
import { getTheme } from "./theme";
import AdminRoutes from "./routes/AdminRoutes";
import "./styles/global.css";

const ThemedApp = () => {
  const { mode } = useThemeMode();
  const theme = getTheme(mode);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <AdminRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

const App = () => (
  <ThemeModeProvider>
    <ThemedApp />
  </ThemeModeProvider>
);

export default App;
